import React, { useState } from "react";
import { toast } from "react-toastify";
import Control from "../../../common/Control";
import SaveBtn from "../../../common/SaveBtn";
import dataService from "../../../../helpers/dataService";
import { TYPES_EXPORT } from "./exportConstants";

/**
 * Bloc « Demander un export » : le fichier se prépare en arrière-plan, le
 * demandeur reçoit un mail avec le lien quand il est prêt (l'API répond 202
 * immédiatement, quel que soit le volume).
 */
const DemanderExportForm = ({ onExportDemande }) => {
  const [type, setType] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  function demanderExport(e) {
    if (e) e.preventDefault();
    if (!type) {
      toast.warning("Choisissez d'abord le type d'export");
      return;
    }
    setIsSaving(true);
    dataService.post(
      "exports",
      { type },
      () => {
        toast.success(
          "Demande enregistrée : vous recevrez un mail avec le lien de téléchargement dès que le fichier sera prêt."
        );
        setType("");
        if (onExportDemande) onExportDemande();
      },
      () => {},
      () => setIsSaving(false)
    );
  }

  return (
    <div className="bg-primary-soft rounded p-3 mb-4">
      <form className="row align-items-end" onSubmit={demanderExport}>
        <div className="col-12 col-md-5">
          <Control
            type="select"
            label="Demander un export"
            name="type"
            value={type}
            change={(e) => setType(e.target.value)}
            datas={TYPES_EXPORT}
            selectFirstLabel="Choisir un type d'export"
          />
        </div>
        <div className="col-12 col-md-auto mt-2 mt-md-0 align-with-control-input">
          <SaveBtn
            save={demanderExport}
            text="Demander"
            type="btn-primary"
            typeBtn="submit"
            margin=""
            isSaving={isSaving}
          />
        </div>
      </form>
    </div>
  );
};

export default DemanderExportForm;
